import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';
import _ from 'lodash';

import Constants from 'constants/Constants';
import SecurityContext from 'utils/permissions/SecurityContext';

import { TextInputLocalized } from 'PMT/components/form';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import CategoryItem from 'PMT/entities/menu/CategoryItem';
import ItemSuggestion from 'PMT/entities/menu/ItemSuggestion';
import LocalizableSelect from 'PMT/components/form/LocalizableSelect';
import SuggestedItem from 'PMT/entities/menu/SuggestedItem.js';

export default class SuggestionForm extends Component {
  static defaultProps = {
    itemSuggestion: null,
  };

  static propTypes = {
    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,
    itemSuggestion: PropTypes.objectOf(ItemSuggestion),
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    itemSuggestion: !_.isNull(this.props.itemSuggestion)
      ? this.props.itemSuggestion.copy()
      : new ItemSuggestion(),
  };

  componentWillReceiveProps(nextProps: Object) {
    if (
      !_.isNull(nextProps.itemSuggestion) &&
      !nextProps.itemSuggestion.equals(this.props.itemSuggestion)
    ) {
      this.setState({
        itemSuggestion: nextProps.itemSuggestion.copy(),
      });
    }
  }

  //
  //
  //

  isEditMode(): boolean {
    return !_.isNull(this.props.itemSuggestion);
  }

  isValid(): boolean {
    return (
      !_.isNull(this.state.itemSuggestion) &&
      !_.isEmpty(this.state.itemSuggestion.linkedItems)
    );
  }

  //
  //
  //

  onItemSelect = option => {
    const itemSuggestion = this.state.itemSuggestion;
    const categoryItem = new CategoryItem();

    if (!_.isNil(option)) {
      const id = option.value;
      const item: MenuOrProduct = this.props.restaurantMenu.getItemById(
        id,
        option.type
      );

      categoryItem.id = id;
      categoryItem.setTypeForObject(item);
    }

    itemSuggestion.item = categoryItem;
    this.setState({
      itemSuggestion,
    });
  };

  onSuggestionsSelect = (options, action) => {
    const itemSuggestion = this.state.itemSuggestion;

    const linkedItems = options.map(option => {
      const suggestedItem = new SuggestedItem();
      // remove first letter to distinguish item type and avoid id conflict
      const id = option.value.substr(1);
      const item = this.props.restaurantMenu.getItemById(id, option.type);

      suggestedItem.id = id;
      suggestedItem.setTypeForObject(item);
      suggestedItem.action = action;
      return suggestedItem;
    });

    itemSuggestion.linkedItems = [
      ...itemSuggestion.linkedItems.filter(linkedItem => {
        return linkedItem.action !== action;
      }),
      ...linkedItems,
    ];

    this.setState({
      itemSuggestion,
    });
  };

  onSuggestionsSelectToAdd = options => {
    this.onSuggestionsSelect(options, SuggestedItem.Action.ADD);
  };

  onSuggestionsSelectToReplace = options => {
    this.onSuggestionsSelect(options, SuggestedItem.Action.REPLACE);
  };

  onLocalizedIntroductionChange = localizedData => {
    const itemSuggestion = this.state.itemSuggestion;

    itemSuggestion.localizedIntroduction = localizedData;

    this.setState({
      itemSuggestion,
    });
  };

  //
  //
  //

  renderSubmit() {
    return (
      <button
        className="btn btn-primary button_submit col-xs-2 col-xs-offset-5"
        onClick={() => this.props.onSubmit(this.state.itemSuggestion)}
        disabled={!this.isValid()}
      >
        {!this.isEditMode()
          ? I18n.tr('menu.suggestions.form.add')
          : I18n.tr('menu.suggestions.form.edit')}
      </button>
    );
  }

  render() {
    const usedSuggestions = this.props.restaurantMenu.suggestions.map(
      ({ item }) => {
        if (
          !this.isEditMode() ||
          (item.id !== this.props.itemSuggestion.item.id &&
            item.type !== this.props.itemSuggestion.item.type)
        ) {
          return item;
        }
      }
    );

    const filterAddedItems = (
      itemsList: Array<SuggestedItem>,
      currentItem: MenuOrProduct
    ) =>
      _.find(
        itemsList,
        item => item.id === currentItem.id && item.type === currentItem.type
      )
        ? false
        : true;

    const possibleItems = [
      ...this.props.restaurantMenu.menus,
      ...this.props.restaurantMenu.products,
    ].filter((item: MenuOrProduct) => {
      return (
        filterAddedItems(this.state.itemSuggestion.linkedItems, item) &&
        !_.find(
          usedSuggestions,
          (us) => us && us.id === item.id && us.type === item.type
        )
      );
    });

    const possibleSuggestions = [
      ...this.props.restaurantMenu.menus,
      ...this.props.restaurantMenu.products,
    ].filter((item: MenuOrProduct) => {
      return (
        filterAddedItems(this.state.itemSuggestion.linkedItems, item) &&
        (!_.isNil(this.state.itemSuggestion.item)
          ? !(
              this.state.itemSuggestion.item.id === item.id &&
              this.state.itemSuggestion.item.type === item.type
            )
          : true)
      );
    });

    let selectedItemValue = null;
    if (
      !_.isNil(this.state.itemSuggestion) &&
      !_.isEmpty(this.state.itemSuggestion.item)
    ) {
      selectedItemValue = {
        value: this.state.itemSuggestion.item.id,
        label: this.props.restaurantMenu.getItemById(
          this.state.itemSuggestion.item.id,
          this.state.itemSuggestion.item.type
        ).name,
      };
    }

    let selectedSuggestionsToAdd = [];
    if (
      !_.isNil(this.state.itemSuggestion) &&
      !_.isNil(this.state.itemSuggestion.linkedItems)
    ) {
      selectedSuggestionsToAdd = this.state.itemSuggestion.linkedItems.map(
        (linkedItem: SuggestedItem) => {
          if (linkedItem.isActionAdd()) {
            return {
              // add first letter to distinguish item type and avoid id conflict
              value: `${(linkedItem.type === 1 ? 'm' : 'p')}${linkedItem.id}`,
              label: this.props.restaurantMenu.getItemById(
                linkedItem.id,
                linkedItem.type
              ).name,
              type: linkedItem.type,
            };
          }
        }
      );
    }

    let selectedSuggestionsToReplace = [];
    if (
      !_.isNil(this.state.itemSuggestion) &&
      !_.isNil(this.state.itemSuggestion.linkedItems)
    ) {
      selectedSuggestionsToReplace = this.state.itemSuggestion.linkedItems.map(
        (linkedItem: SuggestedItem) => {
          if (linkedItem.isActionReplace()) {
            return {
              // add first letter to distinguish item type and avoid id conflict
              value: `${(linkedItem.type === 1 ? 'm' : 'p')}${linkedItem.id}`,
              label: this.props.restaurantMenu.getItemById(
                linkedItem.id,
                linkedItem.type
              ).name,
              type: linkedItem.type,
            };
          }
        }
      );
    }

    return (
      <div className="row suggestions__form">
        <h2 className="col-xs-12">
          {!this.isEditMode()
            ? I18n.tr('menu.suggestions.form.add_suggestion')
            : I18n.tr('menu.suggestions.form.edit_suggestion')}
        </h2>
        <div className="col-xs-4">
          <LocalizableSelect
            name="form-field-item"
            value={selectedItemValue}
            onChange={this.onItemSelect}
            options={possibleItems.map((item: MenuOrProduct) => {
              return {
                label: item.name,
                value: item.id,
                type: item.type,
              };
            })}
          />
        </div>
        <div className="col-xs-8">
          <div className="row">
            <label className="col-xs-4">
              {I18n.tr('menu.suggestions.form.labelReplace')}
            </label>
            <LocalizableSelect
              className="col-xs-8"
              multi={true}
              name="form-field-suggestions-to-replace"
              value={selectedSuggestionsToReplace}
              onChange={this.onSuggestionsSelectToReplace}
              options={possibleSuggestions.map((item: MenuOrProduct) => {
                return {
                  label: item.name,
                  // add first letter to distinguish item type and avoid id conflict
                  value: `${(item.type === 1 ? 'm' : 'p')}${item.id}`,
                  type: item.type,
                };
              })}
            />
          </div>
          <div className="row">
            <label className="col-xs-4">
              {I18n.tr('menu.suggestions.form.labelAdd')}
            </label>
            <LocalizableSelect
              className="col-xs-8"
              multi={true}
              name="form-field-suggestions"
              value={selectedSuggestionsToAdd}
              onChange={this.onSuggestionsSelectToAdd}
              options={possibleSuggestions.map((item: MenuOrProduct) => {
                return {
                  label: item.name,
                  // add first letter to distinguish item type and avoid id conflict
                  value: `${(item.type === 1 ? 'm' : 'p')}${item.id}`,
                  type: item.type,
                };
              })}
            />
          </div>
        </div>

        {/* Suggestion introduction text */}
        <br />
        <br />

        <div className="col-xs-12">
          <label>{I18n.tr('menu.suggestions.form.introduction.title')}</label>

          <TextInputLocalized
            locales={Constants.localesForTranslation}
            values={this.state.itemSuggestion.localizedIntroduction}
            className="form-control"
            onChange={this.onLocalizedIntroductionChange}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
          />
          <em>{I18n.tr('menu.suggestions.form.introduction.explanation')}</em>
        </div>

        {this.renderSubmit()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/suggestions/suggestionForm/SuggestionForm.js